import { FormControlLabel } from "@material-ui/core";
import { CheckBox, Typography } from "@thingsw/pitta-design-system";
import React from "react";

interface SurveyCheckBoxProps {
  item: {
    key: string;
    value: string;
  };
  reasonList: string[];
  setReasonList: (reasonList: string[]) => void;
}

const SurveyCheckBox = ({
  item,
  reasonList,
  setReasonList,
}: SurveyCheckBoxProps) => {
  return (
    <FormControlLabel
      style={{
        gap: 6,
        alignItems: "start",
        margin: 0,
        marginLeft: -2,
      }}
      control={
        <CheckBox
          checked={reasonList.includes(item.value)}
          color="primary"
          onClick={() => {
            if (reasonList.includes(item.value)) {
              setReasonList(reasonList.filter((i) => i !== item.value));
              return;
            }
            setReasonList([...reasonList, item.value]);
          }}
        />
      }
      label={
        <Typography
          variant="Body"
          style={{
            minHeight: 30,
            display: "flex",
            alignItems: "center",
          }}
        >
          {item.value}
        </Typography>
      }
    />
  );
};

export default SurveyCheckBox;
